import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@atenea-cms";
import { FlexLayoutModule } from "@angular/flex-layout";

import { AteneaModule } from "@atenea-cms";

import { Slide, SlideAction } from "./models";

import {
  SlideFormComponent,
  SlideActionFormComponent,
  VideoFormComponent,
} from "./components";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    FlexLayoutModule,
    AteneaModule,
  ],
  exports: [SlideFormComponent, SlideActionFormComponent, VideoFormComponent],
  declarations: [
    SlideFormComponent,
    SlideActionFormComponent,
    VideoFormComponent,
  ],
  providers: [],
})
export class CommonModule {}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/common/common.module.ts